class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
        
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}

function addTradeLogin() {
  let menuDrawer = document.querySelectorAll('.f-drawer-mobile-nav .f-mobile-nav__link')
  let tot = menuDrawer.length
  for(let m = 0; m<tot; m++) {
    if(menuDrawer[m].innerHTML.trim() == "Trade") {
      let childContainer = menuDrawer[m].parentNode.querySelector(".f-mobile-nav__dropdown ul")
      let placeholder = document.createElement("li");
      placeholder.innerHTML = `<li><a href="/account" class="btn btn--primary">Trade login</a></li>`;
      let node = placeholder.firstElementChild;
      childContainer.insertBefore(node, childContainer.firstChild);
    }

    if(menuDrawer[m].innerHTML.trim() == "Mobile Menu Shop") {
      let bespokeLink = document.querySelector('div.bespoke-product-link--wrapper');
      if(bespokeLink != null) {
        let childContainer = menuDrawer[m].parentNode.querySelector(".f-mobile-nav__dropdown ul")
        let placeholder = document.createElement("li");
        placeholder.innerHTML = `<li>`+bespokeLink.innerHTML+`</li>`;
        let node = placeholder.lastElementChild;
        childContainer.insertBefore(node, childContainer.firstChild);
      }
    }
  }
}

function catchEmptyMobileLinks() {
  // Catch empty links in the mobile menu and use to trigger the open and close toggle
  let emptyLinks = document.querySelectorAll('.f-mobile-nav__sub-item--has-child a[href="#"]');
  let tot = emptyLinks.length
  for(let m = 0; m<tot; m++) {
    emptyLinks[m].addEventListener('click', function (e){
      e.preventDefault()
      let parent = this.parentNode
      let collapsible = parent.querySelector('collapsible-tab')
      if(typeof collapsible !== 'undefined') {
        collapsible.toggle()
      }
    });
  }
}

function swapShopToMobile() {
  let level0Links = document.querySelectorAll('.f-mobile-nav__inner > ul > li');
  let tot = level0Links.length
  for(let m = 0; m<tot; m++) {
    let linkElm = level0Links[m].querySelector('.f-mobile-nav__link')
    let linkText = linkElm.text.trim()
    if(linkText == "Shop") {
      linkElm.classList.add('hide')
    }
    else if(linkText == "Mobile Menu Shop") {
      linkElm.text = "Shop";
      if(document.body.classList.contains('trade-user')){
        linkElm.href = '/collections/reco-wall-tile-panels-for-trade';
      }
    }
  }
}

function sampleMobileLink() {
  let mobUserLink = document.querySelector('.f-mobile-nav__addons > a');
  if(mobUserLink != null) {
    var span = document.createElement('a');
    span.innerHTML = 'Best sellers sample pack';
    span.href = '/pages/samples';
    span.className = 'btn btn--outline w-full';
    mobUserLink.parentNode.insertBefore(span, mobUserLink);
  }
}

customElements.define('mobile-nav-toggle', MobileNavToggle)
document.addEventListener('DOMContentLoaded', addTradeLogin, false);
document.addEventListener('DOMContentLoaded', catchEmptyMobileLinks, false);
document.addEventListener('DOMContentLoaded', swapShopToMobile, false);
document.addEventListener('DOMContentLoaded', sampleMobileLink, false);



